import { getOwner } from '@ember/owner';

export default function routeRefresh(emberObject) {
  const owner = getOwner(emberObject);
  if (!owner) {
    return;
  }
  owner.lookup('route:application').refresh();
}
